import Script from 'next/script';

export default function PinnedMap() {
  return (
    <>
      <div id="map-wrap" className="hidden w-full md:flex [&_div]:h-full [&_div]:min-h-[300px] [&_div]:w-full">
        <div id="map" />
      </div>
    </>
  );
}
